<div *ngFor="let drawingCMS of items" class="item">
  <ng-container *ngIf="drawingCMS?.drawingDecorator?.status == 1">
    <div
      class="cmsDrawing-last__item"
      [ngStyle]="
        styleService.getStyleRule(
          undefined,
          [tab.configurations.cardDrawing.background],
          [
            tab.configurations.cardDrawing.border,
            mainTemplate.globalVariables.borders
          ]
        )
      "
    >
      <img [src]="drawingCMS?.drawingDecorator?.imageUrl" class="btn-ico" />
    </div>

    <div class="cmsDrawing-last__item-content">
      <h3
        class="cmsDrawing-last__item-name"
        [ngStyle]="
          styleService.getStyleRule([
            tab.configurations.cardDrawing.balanceText,
            undefined,
            'heading4'
          ])
        "
      >
        {{
          drawingCMS?.universalConnectorData.entry
            | conditionalUppercase
              : styleService.getUppercaseValue(
                  tab.configurations.cardDrawing.balanceText
                )
        }}

        {{
          tab.configurations.cardDrawing.balance
            | conditionalUppercase
              : styleService.getUppercaseValue(
                  tab.configurations.cardDrawing.balanceText
                )
        }}
      </h3>

      <div class="cmsDrawing-last__item-content-bottom">
        <div class="cmsDrawing-last__item-line"></div>

        <!-- Activated -->
        <button
          *ngIf="getButtonState(drawingCMS) === 'activated'"
          class="cmsDrawing-last__item-btn-details"
          [disabled]="drawingCMS?.buttonIsDisabled"
          [ngStyle]="
            styleService.getStyleRule(
              [tab.configurations.cardDrawing.buttonActivated.text],
              [tab.configurations.cardDrawing.buttonActivated.background],
              [tab.configurations.cardDrawing.buttonActivated.border]
            )
          "
          [disabled]="true"
        >
          {{
            tab.configurations.cardDrawing.buttonActivatedText
              ? tab.configurations.cardDrawing.buttonActivatedText
              : ("Drawing detail"
                | conditionalUppercase
                  : styleService.getUppercaseValue(
                      tab.configurations.cardDrawing.buttonActivated.text
                    ))
          }}
        </button>

        <!-- PreActive -->
        <button
          *ngIf="getButtonState(drawingCMS) === 'preActive'"
          [disabled]="drawingCMS?.buttonIsDisabled"
          class="cmsDrawing-last__item-btn-details"
          (click)="activateJoingoDrawing(drawingCMS?.universalConnectorData.id)"
          [ngStyle]="
            styleService.getStyleRule(
              [tab.configurations.cardDrawing.buttonPreActive.text],
              [tab.configurations.cardDrawing.buttonPreActive.background],
              [tab.configurations.cardDrawing.buttonPreActive.border]
            )
          "
          [disabled]="true"
        >
          {{
            tab.configurations.cardDrawing.buttonPreActiveText
              ? tab.configurations.cardDrawing.buttonPreActiveText
              : ("Drawing detail"
                | conditionalUppercase
                  : styleService.getUppercaseValue(
                      tab.configurations.cardDrawing.buttonPreActive.text
                    ))
          }}
        </button>

        <!-- Activate -->
        <button
          *ngIf="getButtonState(drawingCMS) === 'activate'"
          [disabled]="drawingCMS?.buttonIsDisabled"
          (click)="activateJoingoDrawing(drawingCMS?.universalConnectorData.id)"
          class="cmsDrawing-last__item-btn-details"
          [ngStyle]="
            styleService.getStyleRule(
              [tab.configurations.cardDrawing.buttonActivate.text],
              [tab.configurations.cardDrawing.buttonActivate.background],
              [tab.configurations.cardDrawing.buttonActivate.border]
            )
          "
          [disabled]="isDatePast(drawingCMS?.universalConnectorData.conductAt)"
        >
          {{
            tab.configurations.cardDrawing.buttonActivateText
              ? tab.configurations.cardDrawing.buttonActivateText
              : ("Drawing detail"
                | conditionalUppercase
                  : styleService.getUppercaseValue(
                      tab.configurations.cardDrawing.buttonActivate.text
                    ))
          }}
        </button>
      </div>
    </div>
  </ng-container>
</div>